/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementGetRemainPointResponse } from './MemberManagementGetRemainPointResponse';

export type MemberManagementGetRemainPointResponseApiRespoonse = {
    data?: MemberManagementGetRemainPointResponse;
    status?: MemberManagementGetRemainPointResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementGetRemainPointResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

